/* FUNCTIONS : SUBMIT GENERAL FORM */

export let lock = false;

export const set_msg = data => {
	if (data.msg && data.msg != "") {
		console.log(data.msg);
	}
}

export const submit_form = form => {

	if (!lock) {
		lock = true;
		const url = form.dataset.action ? form.dataset.action : form.getAttribute("action");

		fetch(url ? url : window.location.href, {
			method: "POST",
			enctype: 'multipart/form-data',
			body: new FormData(form)
		}).then(r => r.json()).then(data => {
			lock = false;

			const errorFields = form.querySelector('.error');
			if (errorFields) {
				errorFields.classList.remove('error');
			}
			
			if (data.success) {
			   document.location.href = data.redirect; 
			} else {
				if (data.errors) {
					Object.keys(data.errors).forEach(name => {
						const item = form.querySelector(`*[name="${name}"]`);
						if (item) {
							item.classList.add("error");
							const closestGroup = item.closest("label");
							if (closestGroup) { closestGroup.classList.add("error"); }
						}
					});
				}
				
				const errors = document.querySelectorAll(".error");

				if(errors.length > 0){
				   errors[0].scrollIntoView();
				}

				set_msg(data);
			}
		}).catch((error) => {
			lock = false;
			
			console.log('error handing here');
			/*** REMOVE IF LIVE SERVER IS NOT EMPTY ROOT ***/
			if (initVals.webRoot == "") { 
				document.location.href = "/"; 
			} else {
				console.log(error); 
			}
		});
	}
}